export default {"src":"/_next/static/media/Polygon.ae8fd9de.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};